import React from 'react';
import { observer } from 'mobx-react';

import { ApplicationModule } from 'shared/modules';
import { UiButton, UiForm, UiFormControl, UiInput, UiIcon } from 'shared/uikit';
import { outlookConnectQuery, outlookDisconnectQuery } from "shared/queries";
import { useAction, useStore, useValidation } from "shared/hooks";
import { ICONS } from "shared/constants";

import './styles.scss';
import { PermissionEnum } from "shared/enums";

export const PProfileOutlook = observer(() => {
    const store = useStore(() => ({
        isLoading: false,
        isSubmitted: false,
        errorMessage: '',
    }))

    const form = useStore(() => ({
        login: '',
        password: '',
    }));

    const validation = useValidation(form, (rules) => ({
        login: rules.email(),
        password: rules.required()
    }))

    const handleSubmit = async () => {
        store.set("isSubmitted", true);
        store.set("errorMessage", '');
        if (!validation.isValid) {
            return;
        }

        store.set("isLoading", true);
        const { isSuccess, errorMessage, data } = await outlookConnectQuery(form);
        if (isSuccess && data) {
            ApplicationModule.user.update({
                outlookLogin: data.item.outlookLogin
            });
        } else {
            store.set('errorMessage', errorMessage)
        }
        store.set("isLoading", false);
    };

    const handleDisconnect = useAction(() => {
        ApplicationModule.user.update({
            outlookLogin: null
        });
        outlookDisconnectQuery();
    });

    if (ApplicationModule.user.outlookLogin) {
        return (
            <div className='p-user-section p-user-section--16plpr'>
                <div className='p-user-section__title p-user-section__title--4mb'>
                    Интеграция с Outlook
                </div>
                <div className='p-user-section__email'>{ApplicationModule.user.outlookLogin}</div>
                <div className="p-user-section__exit"
                    onClick={handleDisconnect}
                >
                    <UiIcon
                        size={20}
                        icon={ICONS["EXIT_ICON"]}
                    />
                    Выйти из Outlook
                </div>
            </div>
        )
    }

    if (!ApplicationModule.user.can(PermissionEnum.WebCalendarAndReservation)) {
        return null;
    }

    return (
        <UiForm className='p-user-section' onSubmit={handleSubmit}>
            <div className="p-user-section__title p-user-section__title--4mb">Интеграция с Outlook</div>
            <div className="p-profile-form__inner">
                <div className="p-profile-form__field">
                    <UiFormControl
                        isSubmitted={store.isSubmitted}
                        errorMessage={validation.login.errorMessage}
                    >
                        <UiInput
                            name='login'
                            placeholder='Ваш логин Outlook'
                            isPlaceholderFluid
                            onChange={form.handleChange}
                            value={form.login}
                            isError={store.isSubmitted && !validation.login.isValid}
                        />
                    </UiFormControl>
                </div>
                <div className="p-profile-form__field">
                    <UiFormControl
                        isSubmitted={store.isSubmitted}
                        errorMessage={validation.password.errorMessage}
                    >
                        <UiInput
                            name='password'
                            placeholder='Ваш пароль Outlook'
                            isPlaceholderFluid
                            type={UiInput.TYPE.PASSWORD}
                            onChange={form.handleChange}
                            value={form.password}
                            isError={store.isSubmitted && !validation.password.isValid}
                        />
                    </UiFormControl>
                </div>
                <div className="p-profile-form__button">
                    <UiFormControl
                        isSubmitted={store.isSubmitted}
                        errorMessage={store.errorMessage}
                    >
                        <UiButton
                            style={{ width: '100%' }}
                            isSubmit
                            label='Подключить'
                            isLoading={store.isLoading}
                        />
                    </UiFormControl>
                </div>
            </div>
        </UiForm>
    );
});
